import { render, staticRenderFns } from "./courseUser.vue?vue&type=template&id=9f72d266"
import script from "./courseUser.vue?vue&type=script&lang=js"
export * from "./courseUser.vue?vue&type=script&lang=js"
import style0 from "./courseUser.vue?vue&type=style&index=0&id=9f72d266&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports